import axios, { Result } from "@/utils/axios";
import { API_PRIFIX } from "@constants/common";

export interface MenuItem {
  hide: boolean;
  domain_id: number;
  domain_key: string;
  menu_key: string;
  menu_type: "M" | "P";
  operation_key: string;
  menus: MenuItem[];
}

export const fetchMenus = (): Promise<Result<MenuItem[]>> => {
  return axios.post(`/hub/auth/user/menus`, { platform_key: "vendor" });
};

export const fetchUserInfo = () => {
  return axios.get(`${API_PRIFIX}/user/information/getUserInfo`);
};

export const fetchNotification = (userId: number | string) => {
  return axios.get(`${API_PRIFIX}/user/information/getNotification/${userId}`);
};

export const readNotification = (id: number | string) => {
  return axios.get(`${API_PRIFIX}/user/information/readNotification/${id}`);
};
